import { ApplicationError, ApplicationErrorCode } from '@oysterjs/core/graphql';

/** Structured Copilot submit error so UI can branch without string-matching. */
export type CopilotActionError =
  | { kind: 'overage'; message: string }
  | { kind: 'generic'; message: string };

export const isOverageLimitApplicationError = (err: ApplicationError | undefined | null): boolean =>
  err?.code === ApplicationErrorCode.OverageLimitReached;

export const copilotActionErrorFromApplicationError = (
  err: ApplicationError
): CopilotActionError => {
  if (isOverageLimitApplicationError(err)) {
    return { kind: 'overage', message: err.message };
  }
  return { kind: 'generic', message: err.message };
};

export const normalizeCopilotActionError = (
  error: CopilotActionError | string | undefined | null
): CopilotActionError | undefined => {
  if (error == null || error === '') return undefined;
  if (typeof error === 'string') return { kind: 'generic', message: error };
  return error;
};

export const isOverageCopilotActionError = (
  error: CopilotActionError | string | undefined | null
): boolean => normalizeCopilotActionError(error)?.kind === 'overage';
